<template>
    <b-card no-body>
        <b-modal id="receipt-detail-modal" title="Fatura Detayları" size="lg" scrollable ok-only ok-title="Kapat" @hidden="clearForm">
            <receipt-detail-view :item="selectedItem" />
        </b-modal>
        <v-table ref="table" :items-provider="invoiceProvider" :fields="fields" :buttons="buttons" pagination="client">
            <template #filters>
                <div class="row align-items-end">
                    <div class="col-md-4">
                        <b-form-group label="Tedarikçi Kodu">
                            <b-form-input v-model="filters.CariKodu" @keyup.enter="search" placeholder="Tedarikçi koduna göre ara..." />
                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                        <b-form-group label="Fatura Numarası">
                            <b-form-input v-model="filters.FaturaNo" @keyup.enter="search" placeholder="Fatura numarasına göre ara..." />
                        </b-form-group>
                    </div>
                    <div class="col-md-1"></div>
                    <div class="col-md-3">
                        <b-form-group label=" ">
                            <div class="d-flex w-100">
                                <button type="button" class="btn btn-secondary w-100 mr-1" @click="clearFilters">Temizle</button>
                                <button type="button" class="btn btn-primary w-100" @click="search">Ara</button>
                            </div>
                        </b-form-group>
                    </div>
                </div>
            </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard, BFormInput, BFormGroup, BModal } from "bootstrap-vue";
import { WarehouseApi } from "@/api/warehouse/index.js";
import ReceiptDetailView from './components/ReceiptDetailView.vue'; 

export default {
    name: "ReceiptTransferView",
    components: {
        BCard,
        BModal,
        BFormInput,
        BFormGroup,
        ReceiptDetailView
    },
    data() {
        return {
            selectedItem: {},
            filters: {
                CariKodu: "",
                FaturaNo: "",
            },
            fields: [
                { key: "FatUst.FATIRS_NO", name: "Fatura No", thClass: "w-25" },
                { key: "FatUst.CARI_UNVAN", name: "Tedarikçi Ünvanı", thClass: "w-50" },
                { key: "FormattedTarih", name: "Tarih", thClass: "w-15" },
                { key: "CalculatedKalemAdedi", name: "Kalem Adedi", thClass: "w-10" },
            ],
            buttons: [
                { key: "import", icon: "ArrowRightCircleIcon", variant: "success", text: "Depoya Aktar", action: this.confirmImport },
                { key: "detail", icon: "EyeIcon", variant: "info", text: "Detaylar", action: this.showDetailModal },
            ],
        };
    },
    methods: {
        showDetailModal(item) {
            this.selectedItem = item;
            this.$bvModal.show("receipt-detail-modal");
        },
        clearForm() {
            this.selectedItem = {};
        },
        search() {
            this.$refs.table.refresh();
        },
        async invoiceProvider() {
            this.$refs.table.setLoading(true);
            try {
                const response = await WarehouseApi.getPurchaseInvoices(this.filters);
                let items = response.data.Data.Data || [];

                items = items.map((item) => {
                    return {
                        ...item,
                        CalculatedKalemAdedi: item.Kalems && Array.isArray(item.Kalems) ? item.Kalems.length : 0,
                        FormattedTarih: item.FatUst && item.FatUst.Tarih ? new Date(item.FatUst.Tarih).toLocaleDateString("tr-TR") : "",
                    };
                });

                this.$refs.table.setItems(items);
                this.$refs.table.setTotal(items.length);
            } catch (error) {
                this.$result(null, error);
                this.$refs.table.setItems([]);
                this.$refs.table.setTotal(0);
            } finally {
                this.$refs.table.setLoading(false);
            }
        },
        confirmImport(item) {
            const faturaNo = item.FatUst.FATIRS_NO;
            this.$bvModal
                .msgBoxConfirm(`'${faturaNo}' numaralı faturayı depoya aktarmak istediğinize emin misiniz?`, {
                    title: "Lütfen Onaylayın",
                    okVariant: "success",
                    okTitle: "Evet, Aktar",
                    cancelTitle: "İptal",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        this.importInvoice(item.FatUst);
                    }
                });
        },
        importInvoice(faturaUst) {
            this.$refs.table.rowLoading(true);
            const payload = {
                FatirsNo: faturaUst.FATIRS_NO,
                CariKodu: faturaUst.CariKod,
            };
            WarehouseApi.importInvoiceToBuffer(payload)
                .then((res) => {
                    this.$result(res);
                    if (res.data.Success) {
                        this.search();
                    }
                })
                .catch((err) => this.$result(null, err))
                .finally(() => {
                    this.$refs.table.rowLoading(false);
                });
        },
        clearFilters() {
            this.filters = {
                CariKodu: "",
                FaturaNo: "",
            };
            this.search();
        },
    },
};
</script>
